import { LOG_IN, LOG_OUT, SET_SESSION, UPDATE_SESSION } from '@stb-redux/extra-constants/auth';

export const logIn = () => ({
  type: LOG_IN,
});

export const logOut = () => ({
  type: LOG_OUT,
});

export const setSession = (payload) => ({
  type: SET_SESSION,
  payload,
});

export const updateSession = (payload) => ({
  type: UPDATE_SESSION,
  payload,
});
